import { Component, OnInit } from '@angular/core';
import { InsuranceCoverage } from '../models/insurance-coverage';
import { startWith, takeUntil } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { ProtectYourLegacyQuestionnaireStep } from '../models/protect-your-legacy-questionnaire-step';


@Component({
	selector: 'eync-pyl-preview',
	templateUrl: './preview.component.html',
	styleUrls: ['./preview.component.less']
})
export class PreviewComponent extends ProtectYourLegacyQuestionnaireStep implements OnInit {
	insuranceCoverage: InsuranceCoverage;

	ngOnInit() {
		this.form.valueChanges
			.pipe(
				startWith(this.form.value as FormGroup),
				takeUntil(this.unsubscribe$),
			)
			.subscribe((value) => this.insuranceCoverage = new InsuranceCoverage(value));
	}

}
